/**
 * @file Contains constants used troughout the d3 code.
 *
 * @author Juhana Kuparinen <juhana.kuparinen@kvanttori.fi>
 */

export const RADIUS = 2;
export const ARROW = 2.8;
export const STROKE_WIDTH = 0.5;
export const TEXT_SIZE = 0.2;

// Not used at the moment, save graph size between rerenders
// export let graphTransform: null | string = null;
// export const setGraphTransform = (value: string) => (graphTransform = value);
